import { Link } from "@reach/router";
import React, { useContext, useEffect, useState } from "react";
import PaqueteRow from "../../components/paquetes/PaqueteRow";
import { ModalContext } from "../../context/ModalContext";
import { PackagesContext } from "../../context/PackageContext";

const AdminPaquetes = () => {
  const [query, setQuery] = useState("");

  const { modalComponent } = useContext(ModalContext);
  const { paquetes, getAllPaquetes, deletePaquete } =
    useContext(PackagesContext);

  useEffect(() => {
    getAllPaquetes();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const renderPaquetes = () => {
    if (paquetes && paquetes !== null) {
      let paquetesRender = paquetes;
      if (query !== "") {
        paquetesRender = paquetesRender.filter((paquete) =>
          paquete.title.toLowerCase().includes(query)
        );
      }
      if (paquetesRender.length === 0) {
        return <p>No hay paquetes disponibles.</p>;
      }
      return paquetesRender.map((paquete) => (
        <PaqueteRow
          key={paquete.class_package_id}
          paquete={paquete}
          confirmDelete={confirmDelete}
        />
      ));
    }
    return <div className="spinner-border"></div>;
  };

  const confirmDelete = (paquete) => {
    modalComponent(
      "Precaución",
      <>
        <p>
          ¿Estás segura que deseas eliminar el paquete {paquete.title}? Esta
          acción NO puede deshacerse.
        </p>
        <button
          className="btn btn-danger"
          onClick={() => deletePaquete(paquete.class_package_id)}
        >
          Eliminar
        </button>
      </>
    );
  };

  return (
    <div className="container-fluid">
      <div className="row align-items-center mb-2">
        <div className="col col-md-6">
          <h1 className="mb-0">Paquetes</h1>
        </div>
        <div className="col col-md-6 text-end">
          <Link className="btn btn-primary" to="./nuevo">
            + Agregar
          </Link>
        </div>
      </div>
      <div className="card shadow">
        <input
          type="text"
          value={query}
          className="form-control mb-3"
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Buscar paquete por nombre..."
        />
        <div className="row bg-light border py-2 mx-0 bold">
          <div className="col col-md-3">Título</div>
          <div className="col col-md-2">Disponible</div>
          <div className="col col-md-2">Precio</div>
          <div className="col col-md-2">Oferta</div>
          <div className="col col-md-3">Acciones</div>
        </div>
        {renderPaquetes()}
      </div>
    </div>
  );
};

export default AdminPaquetes;
